/**
 * @module app.bdc.list.pistolGripOrderCtrl
 *
 */
define(['angular'], function(angular) {


    function PistolGripOrderCtrl($scope, $uibModalInstance) {
        var self = {};

        self.isPistol = true;
        self.isEncaissement = true;

        self.add = function() {
            $uibModalInstance.close({isPistol: self.isPistol, isEncaissement: self.isEncaissement});
        };

        self.doNotAdd= function() {
            $uibModalInstance.close(false);
        };

        return self;
    }

    PistolGripOrderCtrl.$inject = ['$scope', '$uibModalInstance', '$log'];

    angular.module('app.bdc.list.pistolGripOrderCtrl', ['ui.bootstrap.modal']).controller('PistolGripOrderCtrl', PistolGripOrderCtrl);
});
